import { useGetPortfolioInvestmentsViewQuery } from "../../../services/valuations";

const usePortfolioInvestments = (masterAccountId) => {
    const { data, error, isError, isLoading, isFetching, isUninitialized, refetch } = useGetPortfolioInvestmentsViewQuery({ masterAccountId }/*, { refetchOnMountOrArgChange: true }*/);

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        reload : refetch
    };

};

export default usePortfolioInvestments;